import moment from "moment";

// eslint-disable-next-line import/prefer-default-export
export const renderDate = (date, american = false) => {
  if (!date) return "";

  if (american) {
    const parts = date.split("/");
    return [parts[1], parts[0], parts[2]].join("/");
  }

  return moment(date).format("DD/MM/YYYY");
};
